import ReservationSidebar from '../Commun/ReservationSidebar'
import ReservationHeader from '../Commun/ReservationHeader'
import { useProperty } from '../../PropertyContext';
import { getBookingEngineUrl } from '../../Redux/Slices/BookingEngineSlice';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import './PropertyDetails.css';

export const BookingEngine = () => {
    const { selectedProperty } = useProperty();

    const dispatch = useDispatch();

    const { bookingUrl, loading } = useSelector((state) => state.bookingEngine);

    useEffect(() => {
        if (selectedProperty?.PropertyID) {
            dispatch(getBookingEngineUrl(selectedProperty?.PropertyID));
        }
    }, [dispatch, selectedProperty]);

    const newBookingUrl = bookingUrl.replace(
        "https://booking.bookonnile.com/",
        window.location.origin + "/"
    );

    const tableData = [
        {
            URL: newBookingUrl,
        },
    ];

    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <div className="wrapper property-details-page">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />
                    <div className="container">
                        <div className="page-inner">

                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='card'>
                                        <div className='card-header'>
                                            <h4 className='card-title mb-0 fw-bold'>Booking Engine</h4>
                                        </div>
                                        <div className='card-body'>
                                            <DataTable
                                                value={tableData}
                                                rows={10}
                                                stripedRows
                                                responsiveLayout="scroll"
                                                emptyMessage="No records found"
                                            >
                                                <Column
                                                    field="URL"
                                                    header="URL"
                                                    body={(rowData) => (
                                                        <NavLink
                                                            to={rowData.URL}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {rowData.URL}
                                                        </NavLink>
                                                    )}
                                                />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
